import { render } from "./CampaignEdit.vue?vue&type=template&id=7c73da07&ts=true"
import script from "./CampaignEdit.vue?vue&type=script&lang=ts"
export * from "./CampaignEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__